import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import MyLineChart from './charts/MyLineChart';
import MyAreaChart from './charts/MyAreaChart';
import MyBarChart from './charts/MyBarChart';
import MyRadarChart from './charts/MyRadarChart';
import SeriesCompareLineChart from './charts/SeriesCompareLineChart';
import MultiSeriesRadarChart from './charts/MultiSeriesRadarChart';
import SeriesCompareScatterChart from './charts/SeriesCompareScatterChart';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
});

function ChartInsight(props) {
    const { classes } = props;
    const size = props.data.length <= 2 ? 6 : 4;
    return (
        <div className={classes.root}>
            <Grid container spacing={16}>
                {props.data.map((record, index) =>
                    <Grid key={index} item xs={size} sm={size}>
                        <Paper className={classes.paper}>
                            <Typography component="h2">
                                {record.title}
                            </Typography>
                            {renderChart(record, index)}
                        </Paper>
                    </Grid>
                )}
            </Grid>
        </div>
    );
}

ChartInsight.defaultProps = {

};

const renderChart = (datum, key) => {
    switch (datum.type) {
        case "LineChart":
            return <MyLineChart key={key} {...datum} />
        case "SeriesCompareLineChart":
            return <SeriesCompareLineChart key={key} {...datum} />
        case "SeriesCompareScatterChart":
            return <SeriesCompareScatterChart key={key} {...datum} />
        case "MultiSeriesRadarChart":
            return <MultiSeriesRadarChart key={key} {...datum} />
        case "AreaChart":
            return <MyAreaChart key={key} {...datum} />
        case "BarChart":
            return <MyBarChart key={key} {...datum} />
        case "RadarChart":
            return <MyRadarChart id={key} key={key} {...datum} />
        default:
            <h1>No chart found</h1>
    }
}

export default withStyles(styles)(ChartInsight);


// WEBPACK FOOTER //
// ./src/components/ChartInsight.js